exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#191f26",
	"menuActiveText": "#191f26",
	"subMenuActiveText": "#1f6ff0",
	"menuBg": "#fff",
	"menuHover": "#1f6ff0",
	"subMenuBg": "#fff",
	"subMenuHover": "#1f6ff0",
	"sideBarWidth": "200px",
	"minWidth": "48px",
	"sideBarSize": "1rem"
};